import { FormItemType } from '../../modules/shared/form-builder/constants/form-builder.constants'

export { default as GoogleIcon } from './google-icon.png'
export { default as CalendarIcon } from './calendar.svg'
export { default as CheckRoundedIcon } from './check-rounded.svg'
export { default as CheckSquareIcon } from './check-square.svg'
export { default as DotRoundedIcon } from './dot-rounded.svg'
export { default as DownloadIcon } from './download.svg'
export { default as HeaderIcon } from './header.svg'
export { default as NumberIcon } from './number.svg'
export { default as TextIcon } from './text.svg'
export { default as CopyIcon } from './copy.svg'
export { default as TrashIcon } from './trash.svg'

import { ReactComponent as ArrowDownIconComponent } from './arrow-down.svg'
import { ReactComponent as ArrowLeftIconComponent } from './arrow-left.svg'
import { ReactComponent as ArrowUpIconComponent } from './arrow-up.svg'
import { ReactComponent as CalendarIconComponent } from './calendar.svg'
import { ReactComponent as CheckRoundedIconComponent } from './check-rounded.svg'
import { ReactComponent as CheckSquareIconComponent } from './check-square.svg'
import { ReactComponent as CopyIconComponent } from './copy.svg'
import { ReactComponent as DotRoundedIconComponent } from './dot-rounded.svg'
import { ReactComponent as DownloadIconComponent } from './download.svg'
import { ReactComponent as DragDotsIconComponent } from './drag-dots.svg'
import { ReactComponent as HeaderIconComponent } from './header.svg'
import { ReactComponent as NumberIconComponent } from './number.svg'
import { ReactComponent as TextIconComponent } from './text.svg'
import { ReactComponent as TrashIconComponent } from './trash.svg'

export enum IconEnum {
  Calendar = 'Calendar',
  CheckRounded = 'CheckRounded',
  CheckSquare = 'CheckSquare',
  DotRounded = 'DotRounded',
  Download = 'Download',
  Header = 'Header',
  Number = 'Number',
  Text = 'Text',
  Copy = 'Copy',
  Trash = 'Trash',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  DragDots = 'DragDots',
  ArrowLeft = 'ArrowLeft',
}

const icons: any = {
  [IconEnum.Calendar]: CalendarIconComponent,
  [IconEnum.CheckRounded]: CheckRoundedIconComponent,
  [IconEnum.CheckSquare]: CheckSquareIconComponent,
  [IconEnum.DotRounded]: DotRoundedIconComponent,
  [IconEnum.Download]: DownloadIconComponent,
  [IconEnum.Header]: HeaderIconComponent,
  [IconEnum.Number]: NumberIconComponent,
  [IconEnum.Text]: TextIconComponent,
  [IconEnum.Copy]: CopyIconComponent,
  [IconEnum.Trash]: TrashIconComponent,
  [IconEnum.ArrowUp]: ArrowUpIconComponent,
  [IconEnum.ArrowDown]: ArrowDownIconComponent,
  [IconEnum.DragDots]: DragDotsIconComponent,
  [IconEnum.ArrowLeft]: ArrowLeftIconComponent,
}

const iconTypeMap: any = {
  [FormItemType.Checkbox]: IconEnum.CheckSquare,
  [FormItemType.Date]: IconEnum.Calendar,
  [FormItemType.DateRange]: IconEnum.Calendar,
  [FormItemType.Upload]: IconEnum.Download,
  [FormItemType.Header]: IconEnum.Header,
  [FormItemType.ImageUpload]: IconEnum.Download,
  [FormItemType.Select]: IconEnum.CheckRounded,
  [FormItemType.InputNumber]: IconEnum.Number,
  [FormItemType.NumberRange]: IconEnum.Number,
  [FormItemType.Radio]: IconEnum.DotRounded,
  [FormItemType.Input]: IconEnum.Text,
  [FormItemType.Textarea]: IconEnum.Text,
}

export function getIcon(name: IconEnum) {
  return icons[name]
}

export function getIconNameByType(type: FormItemType) {
  return iconTypeMap[type]
}
